/* istanbul ignore file */
import React from 'react';
import styles from './footer.module.scss';
import { ATMGrid } from '../atoms/ATMGrid/ATMGrid.component';
import socalLogo from '../../assets/images/socalLogo.png';
// import digitalCert from '../../../assets/images/digitalCert.png';
import { ImageGroup, Image } from 'semantic-ui-react';
import moment from 'moment';

export default function FooterComponent (){
    const footerHeader = `© 1998 - ${moment().year()} `
    return (
        <>
            <div className={styles.footer}>
                <hr className={styles.firstHR} />
                <ATMGrid stackable padded columns="equal">
                    <ATMGrid.Row
                        columns={2}
                        className={styles.firstLine}
                    >
                        <ATMGrid.Column computer={16} tablet={16}>
                            <ImageGroup size="tiny">
                                <Image src={socalLogo} alt="socalLogo" />
                                {/* <Image src={digitalCert} alt="digitalCert" /> */}
                            </ImageGroup>
                        </ATMGrid.Column>
                        <ATMGrid.Column
                            textAlign="left"
                            className={styles.footerText}
                            computer={16}
                            tablet={16}
                        >
                           
                            <p>
                                Southern California Gas Company is a subsidiary of Sempra®. {footerHeader} 
                                Southern California Gas Company. SoCalGas® is a registered trademark of Southern California Gas Company. 
                                The trademarks used herein are the property of their respective owners. All rights reserved.
                            </p>
                        </ATMGrid.Column>
                    </ATMGrid.Row>

                    <ATMGrid.Row className="sempraNoPaddingTop">
                        <hr className={styles.secondHR} />
                    </ATMGrid.Row>

                    <ATMGrid.Row className="sempraNoPaddingTop">
                        <ATMGrid.Column computer={3} tablet={4} className={styles.footerText}>
                            <a href='https://www.socalgas.com/terms-and-conditions' target='_blank' rel="noreferrer" className='sempraFooterLink'>Terms & Conditions</a>
                        </ATMGrid.Column>
                        <ATMGrid.Column computer={3} tablet={4} className={styles.footerText}>
                            <a href='https://doi.org/10.6028/NIST.SP.800-53r5' target='_blank' rel="noreferrer" className='sempraFooterLink'>Security Controls Criteria</a>
                        </ATMGrid.Column>
                        <ATMGrid.Column computer={3} tablet={4} className={styles.footerText}>
                            <a href='https://www.socalgas.com/privacy-center' target='_blank' rel="noreferrer" className='sempraFooterLink'>Privacy Center</a>
                        </ATMGrid.Column>
                    </ATMGrid.Row>
                </ATMGrid>
            </div>
        </>
    )
}


